import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Tv, Loader2 } from "lucide-react";
import api, { formatApiError } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import SocialAuth from "@/components/SocialAuth";

const BG = "https://images.unsplash.com/photo-1489599849927-2ee91cede3ba?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600";

export default function Login() {
  const nav = useNavigate();
  const { authenticate } = useAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError(""); setLoading(true);
    try {
      const { data } = await api.post("/auth/login", { email, password });
      authenticate(data.token, data.user);
      nav("/profiles");
    } catch (err) {
      setError(formatApiError(err.response?.data?.detail) || "Login failed");
    } finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen relative grid place-items-center px-4" data-testid="login-page">
      <img src={BG} alt="" className="absolute inset-0 w-full h-full object-cover opacity-30" />
      <div className="absolute inset-0 bg-gradient-to-t from-[#0A0A0C] to-[#0A0A0C]/60" />
      <div className="relative z-10 w-full max-w-md backdrop-blur-xl bg-black/60 border border-white/10 rounded-2xl p-8 shadow-2xl animate-fade-up">
        <Link to="/" className="flex items-center gap-2 justify-center mb-6">
          <Tv className="text-brand" size={28} />
          <span className="font-head font-extrabold text-2xl">NeTime<span className="text-brand">TV</span></span>
        </Link>
        <h1 className="font-head text-2xl font-bold mb-1">Welcome back</h1>
        <p className="text-zinc-400 text-sm mb-6">Sign in to continue watching.</p>
        {error && <div data-testid="login-error" className="bg-brand/20 border border-brand/40 text-sm rounded-lg px-4 py-2 mb-4">{error}</div>}
        <form onSubmit={submit} className="space-y-4">
          <input data-testid="login-email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} placeholder="Email"
            className="w-full bg-white/5 border border-white/15 rounded-lg px-4 py-3 outline-none focus:border-brand transition-colors" />
          <input data-testid="login-password" type="password" required value={password} onChange={(e) => setPassword(e.target.value)} placeholder="Password"
            className="w-full bg-white/5 border border-white/15 rounded-lg px-4 py-3 outline-none focus:border-brand transition-colors" />
          <button data-testid="login-submit" disabled={loading}
            className="w-full bg-brand hover:bg-brand-hover font-bold py-3 rounded-lg transition-colors flex items-center justify-center gap-2 disabled:opacity-60">
            {loading && <Loader2 className="animate-spin" size={18} />} Sign In
          </button>
        </form>
        <div className="mt-5"><SocialAuth /></div>
        <p className="text-sm text-zinc-400 mt-6 text-center">
          New here? <Link to="/register" className="text-white font-semibold hover:text-brand">Create a free account</Link>
        </p>
      </div>
    </div>
  );
}
